"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDateRange = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var datetime_1 = require("@blueprintjs/datetime");
exports.StyledDateRange = (0, styled_components_1.default)(datetime_1.DateRangeInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & ul.bp3-daterangepicker-shortcuts {\n    & li {\n      ", "\n    }\n  }\n"], ["\n  & ul.bp3-daterangepicker-shortcuts {\n    & li {\n      ", "\n    }\n  }\n"])), function (props) {
    return props.isUserDefined &&
        "\n      &:not(:last-child) {\n        & a {\n          background-color: white !important;\n          color: black !important;\n        }\n      }\n      &:last-child {\n        & a {\n          background-color: #137cbd !important;\n          color: white !important;\n        }\n      }\n      ";
});
var templateObject_1;
